module.exports = __webpack_public_path__ + "img/55.787e666c.jpg";